// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.feedback-invoice-draft__note[data-v-26ab4609] {\n  margin-top: 10px;\n  color: #ff712c;\n  opacity: 0.8;\n}\n.feedback-invoice-draft__cancel-policy[data-v-26ab4609] {\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
